import { toast } from "react-toastify";

export const handleSuccess = (msg)=>{
    toast.success(msg, {
        position : 'top-right'
    })
}

export const handleError = (msg)=>{
    toast.error(msg,  {
        position : 'top-right'
    })
}
export const handleInfo= (msg)=>{
    toast.info(msg, {
        position : 'top-right'
    })
}

//Global Loading for lazy loading
export const GlobalLoading = () => {
    return (
        <div className="flex items-center justify-center h-full">
            <div className="w-8 h-8 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        </div>
    )
}